import { NButton, NIcon } from 'naive-ui';
import { defineComponent, h, type Component, type PropType } from 'vue';
import { RouterLink, useLink } from 'vue-router';

export const AppButton = defineComponent({
	props: {
		/// @ts-expect-error error esperado
		...RouterLink.props,
		to: {
			type: Object,
			default: undefined,
		},
		icon: {
			type: Object as PropType<Component>,
			default: null,
		},
		content: {
			type: String as PropType<string>,
			default: undefined,
		},
		gold: {
			type: Boolean,
			default: false,
		},
	},
	setup(props, { attrs }) {
		//@ts-expect-error problema de type
		const { navigate, href } = useLink(props);
		const goldClass = props.gold ? 'btn-action-gold' : undefined;

		if (props.to)
			return () => (
				<NButton
					{...attrs}
					class={[attrs.class, goldClass]}
					type="primary"
					href={href.value}
					tag="a"
					onClick={navigate}
				>
					{{
						icon: () => (props.icon ? <NIcon component={props.icon} /> : ''),
						default: () => props.content,
					}}
				</NButton>
			);

		return () => (
			<NButton {...attrs} class={[attrs.class, goldClass]} type="primary">
				{{
					icon: () => (props.icon ? <NIcon>{h(props.icon)}</NIcon> : ''),
					default: () => props.content,
				}}
			</NButton>
		);
	},
});

export default AppButton;
